import { Injectable, Inject } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import * as _ from 'lodash';
import { CacheService } from './cache.service';

@Injectable({
    providedIn: "root"
})
export class TypeValorationReportService {

    className = 'TypeValorationReportService';

    constructor(private http: HttpClient, @Inject("environment") private environment: any, private cacheService: CacheService) { }

    getAll(cache = true, cacheKey = "allValorationReport"): any {
        if (this.cacheService.canUseCache(cacheKey) && cache) {
            return this.cacheService.getCacheData(cacheKey);
          } else {
            let observable = this.http.get(this.environment.base_URL + "/types-valoration-report").pipe(map((res: any) => {
              let listOrdered = _.orderBy(res, ['order'], ['desc']);
              this.cacheService.updateCacheData(listOrdered, cacheKey)
              return listOrdered;
            }))
            this.cacheService.updateCacheReq(cacheKey);
            return observable;
          }
    }
}    